module.exports = __webpack_public_path__ + "img/Group 1840@2x.ea542813.png";